import { Module } from "gql/graphql";

export const CRM = Module.Crm;
export const HR = Module.Hr;
export const SURVEY = Module.Survey;
export const SUPERSET = Module.Superset;
export const FINANCE = Module.Finance;
export const RECRUIT = Module.Recruit;
export const SIGN = Module.Sign;
